/* 右侧菜单*/
export const theme_slider = {
  menuText: '#bfcbd9',
  menuActiveText: '#409EFF',
  subMenuActiveText: '#f4f4f5',
  menuBg: '#304156',
  menuHover: '#263445',
  subMenuBg: '#1f2d3d',
  subMenuHover: '#001528',
  sideBarWidth: '210px'
}
  
/* 上传code配置 */
export const UPLOAD_CODE = {
  album: 'house-album',
  sand: 'house-sand-table',
  layout: 'house-layout',
  news:'news',
  wiki:'wikipedia',
  platform:'platform',
  topic:'topic',
  houseVideo:'house-video',
  newsVideo:'news-video',
  wikiVideo:'wiki-video',
  houseTrendVideo:'house-trend-video',
  topicTemplate:'topic-template',
  siteVerify:'site-verify'
}

/* 资讯模板 */
export const NEWS_MODEL = {
  news_types: [
      {id: 1, name: '区域类'},
      {id: 2, name: '地铁类'},
      {id: 3, name: '开盘类'},
      {id: 4, name: '入住类'},
      {id: 5, name: '价格类'},
      {id: 6, name: '房价类'},
      {id: 7, name: '长尾类'},
      {id: 8, name: '测评类'},
      {id: 9, name: '对比类'},
      {id: 10, name: '噱头类'},
      {id: 11, name: '清尾盘点类'},
  ],
  body_type: [
      {id: 1, name: '标题'},
      {id: 2, name: '关键词'},
      {id: 3, name: '正文'},
  ],
 
};